import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationTH from './locales/th/translation.json';
import translationEN from './locales/en/translation.json';
import { LANG_STORAGE_KEY } from './utils/i18nLocale';

const resources = {
  th: {
    translation: translationTH,
  },
  en: {
    translation: translationEN,
  },
};

const stored =
  typeof window !== 'undefined' ? window.localStorage.getItem(LANG_STORAGE_KEY) : null;
const initialLng = stored === 'en' || stored === 'th' ? stored : 'th';

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: 'th',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANG_STORAGE_KEY, lng);
  }
});

export default i18n;
